var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-load-more"},[_c('el-button',{attrs:{"type":"text","loading":_vm.loading},on:{"click":_vm.loadMore}},[(_vm.last)?_c('span',[_vm._v(_vm._s(_vm.$t('commons.MoreInfo.last')))]):(_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.$t('commons.MoreInfo.loading')))]):_c('span',[_vm._v(_vm._s(_vm.$t('commons.MoreInfo.more')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }